import { Link, Link as RouterLink } from 'react-router-dom';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Grid,
    CardActions,
    Button,
    Typography,
    CreditActions,
  } from '@material-ui/core';
  import { orange, green, red } from '@material-ui/core/colors';
  import AutoGraphIcon from '@material-ui/icons/AutoGraph';
  import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
  import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';


  const TasksProgress = (props) => (
    <Card
      sx={{ height: 'auto' }}
      {...props}
    >
      <CardContent>
      <Grid
        container
        spacing={1}
      >
        <Grid item className="flex-grow-1">
          <Typography
              color="primary"
              variant="h6"
            >
          CREDIT PROGRESS
            </Typography>
            <Box sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
             Increase
            </Typography>
            <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <ArrowUpwardIcon sx={{ color: green[900] }} />
        <Typography
          variant="body2"
          sx={{
            color: green[900],
            mr: 1
          }}
        >
          50%
        </Typography>
        <Typography
          color="textSecondary"
          variant="caption"
          >
         Principal Amount
        </Typography>
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <ArrowUpwardIcon sx={{ color: green[900] }} />
        <Typography
          variant="body2"
          sx={{
            color: green[900],
            mr: 1
          }}
        >
          50%
        </Typography>
        <Typography
          color="textSecondary"
          variant="caption"
        >
         Term period
        </Typography>
      </Box>
          
              </Box>
              <Box sx={{
                   m: 1,   
                   alignItems: 'center'
              }}>
                    <Typography
              color="textSecondary"
              variant="caption"
            >
             Decrease
            </Typography>
            <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ArrowDownwardIcon sx={{ color: red[900] }} />
          <Typography
            sx={{
              color: red[900],
              mr: 1
            }}
            variant="body2"
          >
            5%
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
            >
           Rate
          </Typography>
        </Box>
        </Box>

              
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: orange[600],
                height: 56,
                width: 56
              }}
            >
              <AutoGraphIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions className="center-element">
        <Button size="small" component={RouterLink} to="/app/financing" >Learn More</Button>
      </CardActions>
    </Card>
  );
  
  export default TasksProgress;